import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTableComponent } from './custom-table.component';
import { TableModule } from '@airnauts/ng-components/table';
import { StackPaginatorModule } from '../stack-paginator/stack-paginator.module';


@NgModule({
  declarations: [CustomTableComponent],
  imports: [
    CommonModule,
    TableModule,
    StackPaginatorModule,
  ],
  exports: [CustomTableComponent],
})
export class CustomTableModule { }
